import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

export default function AccessDeniedPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const role = user?.role;

  const homePath = role === 'campaign_manager' ? '/my-candidates' : '/dashboard';
  const homeLabel = role === 'campaign_manager' ? 'Go to my candidates' : 'Go to dashboard';

  function handleSignOut() {
    logout();
    navigate('/login');
  }

  return (
    <div className="login-shell" data-testid="access-denied-page">
      <div className="login-card" style={{ maxWidth: 480 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <i className="bi bi-shield-lock" style={{ fontSize: 44, color: 'var(--bs-warning)' }} aria-hidden="true" />
        </div>
        <h2 style={{ fontSize: '1.4rem', marginBottom: 6, textAlign: 'center' }}>Access denied</h2>
        <p className="text-muted" style={{ fontSize: '0.92rem', textAlign: 'center', marginBottom: 22 }}>
          You don't have permission to view this page.
          {role === 'campaign_manager' && ' Campaign managers can only access candidates assigned to them.'}
        </p>
        <div className="d-grid gap-2">
          <Button as={Link} to={homePath} variant="primary" data-testid="access-denied-home-button">
            {homeLabel}
          </Button>
          <Button variant="link" onClick={handleSignOut} className="text-muted" data-testid="access-denied-signout-button">
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
